// src/pages/Verification.jsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Image,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import logo from '../assets/logo.png';

const Verification = () => {
  return (
    <Container maxW="md" py={12}>
      <VStack spacing={6} align="center">
        <Image src={logo} alt="Draw Your Goods" height="60px" />
        
        <Icon as={CheckCircleIcon} w={20} h={20} color="green.500" />
        
        <Heading size="lg" textAlign="center" color="brand.primary">
          Verifique seu e-mail
        </Heading>
        
        <Box textAlign="center">
          <Text fontSize="md" color="gray.600" mb={4}>
            Enviamos um link de verificação para o seu e-mail. 
            Por favor, clique nele para ativar sua conta.
          </Text>
          
          <Text fontSize="md" color="gray.700">
            Não recebeu o e-mail? Verifique sua pasta de spam ou
            solicite um novo link de verificação.
          </Text>
        </Box>
        
        <Button
          colorScheme="blue"
          bgGradient="linear(to-r, brand.primary, brand.secondary)"
          color="white"
          size="lg"
          width="full"
          _hover={{
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
          }}
        >
          Reenviar e-mail de verificação
        </Button>
        
        <Button
          as={RouterLink}
          to="/login"
          variant="outline"
          color="brand.primary"
          borderColor="brand.primary"
          size="lg"
          width="full"
        >
          Voltar para login
        </Button>
      </VStack>
    </Container>
  );
};

export default Verification;